export default function backToTop () {
	const button = document.querySelector('.footer-top-link');
	if (! button) return;

	button.addEventListener('click', () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});
}
